import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, withLatestFrom } from 'rxjs/operators';

import { FeatureFlagSelectors } from '@app/core/feature-flags/feature-flag.selectors';
import { FeatureFlags } from '@app/core/feature-flags/feature-flags';
import { ConsumerRegistrationActions } from '@app/registration/consumer/action-types';
import * as PrepaidEnrollmentConversionActions from '@app/registration/prepaid-enrollment-conversion/prepaid-enrollment-conversion.actions';
import { ModalTemplateComponent } from '@app/shared';

@Injectable()
export class SharedEffects {
  constructor(
    private actions$: Actions,
    private featureFlagSelectors: FeatureFlagSelectors,
    private modalService: NgbModal,
  ) {}

  showTimeoutModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ConsumerRegistrationActions.showTimeoutModal, PrepaidEnrollmentConversionActions.showTimeoutModal),
        withLatestFrom(this.featureFlagSelectors.getFeatureFlag(FeatureFlags.REACT_TO_SUBMIT_TIMEOUT)),
        map(([_action, isFeatureEnabled]) => {
          if (isFeatureEnabled) {
            this.showTimeoutModal();
          }
        }),
      ),
    { dispatch: false },
  );

  dismissTimeoutModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ConsumerRegistrationActions.dismissTimeoutModal, PrepaidEnrollmentConversionActions.dismissTimeoutModal),
        map(() => {
          this.dismissTimeoutModal();
        }),
      ),
    { dispatch: false },
  );

  /* Note - if needed in the future, we can refactor to take inputs for modal content. */
  private showTimeoutModal(): void {
    const modal = this.modalService.open(ModalTemplateComponent, { windowClass: 'mt-5' })
      .componentInstance as ModalTemplateComponent;
    modal.heading = 'Uh-oh';
    modal.subheader =
      'Looks like this is taking a bit longer than usual. You can continue waiting, or refresh and try again.';
    modal.primaryCallToActionLabel = 'Okay';

    modal.primaryCallToAction.subscribe(() => this.dismissTimeoutModal());
  }

  private dismissTimeoutModal(): void {
    this.modalService.dismissAll();
  }
}
